export const replaceSlashes = (input: string) => {
  return input.replaceAll("%2F", "/").replace(/\/$/, "");
};
